
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import SolarPlans from './components/SolarPlans';
import WhyChooseUs from './components/WhyChooseUs';
import HowItWorks from './components/HowItWorks';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <SolarPlans />
        <WhyChooseUs />
        <HowItWorks />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
